module.exports = __webpack_public_path__ + "static/media/ic_check.846830c6.svg";